var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "messageForm",
          attrs: { model: _vm.message, "label-width": "80px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "留言内容" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: 250,
                  rows: 2,
                  placeholder: "请输入留言内容，限定250个字以内。"
                },
                model: {
                  value: _vm.message.memo,
                  callback: function($$v) {
                    _vm.$set(_vm.message, "memo", $$v)
                  },
                  expression: "message.memo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "联系邮箱" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系邮箱" },
                model: {
                  value: _vm.message.email,
                  callback: function($$v) {
                    _vm.$set(_vm.message, "email", $$v)
                  },
                  expression: "message.email"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("messageForm")
                    }
                  }
                },
                [_vm._v("提交留言")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1d47fba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1d47fba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/GuestBook.vue
// module id = null
// module chunks = 